import React from 'react'
import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ModalWrapper from './ModalWrapper'
import { BasicModalProps } from '../../types/modals'
import { CityRequestForm } from './CityRequestForm'
import './OthersModal.css'
import './Modals.css'

const { Title, Paragraph } = Typography

export const OthersModal: React.FC<BasicModalProps> = ({ isOpen, onClose }) => {
    const { t } = useTranslation()

    return (
        <ModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            width={560}
            className="others-modal"
        >
            <div className="modal-content">
                <div className="others-modal-container">
                    <div className="others-modal-content">
                        <div className="text-container">
                            <Title className="title" level={2}>
                                {t('modals.others.title')}
                            </Title>
                            <Paragraph className="paragraph">
                                {t('modals.others.description')}
                            </Paragraph>

                            <CityRequestForm onSuccess={onClose} />
                        </div>
                    </div>
                </div>
            </div>
        </ModalWrapper>
    )
}
